<template>
  <!-- 待办事务等表格页 -->
  <el-container class="worklist">
    <el-header class="td-header">
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <router-link
          tag="span"
          to="/"
          class="tdhl-title"
        >主页概览</router-link>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">事务中心</span>
      </div>
      <router-link
        tag="span"
        to="/"
        class="tdh-right"
      >返回到概览</router-link>
    </el-header>
    <el-main style="padding-top: 0;">
      <div class="td-main-content">
        <div class="tdmc-header">
          <div class="tdmch-left">
            <div
              v-for="(item,index) in tabData"
              :key="index"
              :class="{'tdmchl-item':true, 'tdmchl-item-active': index === activeTab}"
              @click="handleTabChange(index)"
            >{{ item.title }}({{ item.num }})</div>
          </div>
        </div>
        <component
          :is="currentComponent"
          @changetabnum="changeTabNum"
        />
      </div>
    </el-main>
  </el-container>
</template>
<style lang="scss" scoped>
</style>
<script>
import service from '@/utils/service'
import '../css/worklist/index.scss'
import Applyfor from './applyfor'
import Completed from './completed'
import Todo from './todo'
import Urgent from './urgent'
import Draftbox from './draftbox'
export default {
  components: {
    Applyfor,
    Completed,
    Todo,
    Urgent,
    Draftbox
  },
  data () {
    return {
      activeTab: 0,
      currentComponent: Todo,
      tabData: [
        {
          title: '待办/催办',
          num: 0,
          path: 'todo'
        },
        {
          title: '我的传阅',
          num: 0,
          path: 'urgent'
        },
        {
          title: '我的申请',
          num: 0,
          path: 'applyfor'
        },
        {
          title: '我的办结',
          num: 0,
          path: 'completed'
        },
        {
          title: '我的草稿',
          num: 0,
          path: 'draftbox'
        }
      ]
    }
  },
  mounted () {
    this.getTab()
  },

  methods: {
    // 点击查询
    searchHandle () { },
    getTab () {
      service.get('/v1/application/appData')
        .then(res => {
          this.tabData[0].num = res.data.todo
          this.tabData[1].num = res.data.myRead
          this.tabData[2].num = res.data.myApply
          this.tabData[3].num = res.data.myComplete
          this.tabData[4].num = res.data.myDarft
        }).catch(error => {
          this.$swMessage.error(error)
        })
    },
    handleTabChange (index) {
      this.activeTab = index
      switch (index) {
        case 0:
          this.currentComponent = Todo
          break
        case 1:
          this.currentComponent = Urgent
          break
        case 2:
          this.currentComponent = Applyfor
          break
        case 3:
          this.currentComponent = Completed
          break
        case 4:
          this.currentComponent = Draftbox
          break
        default:
          this.currentComponent = Todo
      }
    }
  }
}
</script>

<style>
</style>
